var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[(_vm.loading)?_c('main-loader'):_c('v-col',{attrs:{"cols":_vm.cols}},[_c('canvas',{attrs:{"id":`chart-${_vm.name}`}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }